// extracted by mini-css-extract-plugin
export var fadeInAnimation = "textwithlist-module--fadeInAnimation--4eff8";
export var list = "textwithlist-module--list--2eae2";
export var listItem = "textwithlist-module--listItem--8b7c0";
export var text = "textwithlist-module--text--5d61a";
export var wrapper = "textwithlist-module--wrapper--b2fdc";